module.exports = __webpack_public_path__ + "static/img/can-mangolime-bublyburst@3x.1ddbd19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-mangolime-bublyburst@3x.png
// module id = IQWT
// module chunks = 0